import PageHeader from "../components/PageHeader";
import { useMyMember } from "../../hooks/useMyMember";
import { useParcoursList } from "../../hooks/useParcoursList";
import { useLieuxList } from "../../hooks/useLieuxList";

function MetricCard({ label, value, loading }: { label: string; value: number | string; loading?: boolean }) {
  return (
    <div className="bo-metric">
      <div className="bo-metric__label">{label}</div>
      <div className="bo-metric__value">{loading ? "…" : value}</div>
    </div>
  );
}

export default function DashboardPage() {
  const me = useMyMember();
  const parcoursCount = useParcoursList({ page: 0, size: 1 });
  const parcoursAll = useParcoursList({ page: 0, size: 200, sort: "createdAt,desc" });
  const lieux = useLieuxList({ page: 0, size: 1 });

  const totalArtistNames =
    parcoursAll.data?.content.reduce((sum, p) => sum + (p.artists?.length ?? 0), 0) ?? null;

  return (
    <div>
      <PageHeader
        title="Tableau de bord"
        description={
          me.data
            ? `Bienvenue, ${me.data.userName ?? me.data.userId}`
            : "Bienvenue dans l'espace d'administration."
        }
      />
      <div className="bo-metric-grid">
        <MetricCard
          label="Parcours"
          value={parcoursCount.data?.totalElements ?? "—"}
          loading={parcoursCount.isLoading}
        />
        <MetricCard
          label="Artistes (cumul)"
          value={totalArtistNames ?? "—"}
          loading={parcoursAll.isLoading}
        />
        <MetricCard label="Lieux" value={lieux.data?.totalElements ?? "—"} loading={lieux.isLoading} />
      </div>
    </div>
  );
}
